import { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPen, faX } from '@fortawesome/free-solid-svg-icons';
import { CMM } from '../../Lib/Cmm.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { etcStore } from 'store/etcStore';
import Modal from 'react-modal';
import styled from 'styled-components';
import Header from "components/Headers/Header.js";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";
import { fetchAxios, postAxios, postNoauth } from 'Lib/GetAxios';
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  Container,
  Row,
  Col,
  List,
  Input,
} from "reactstrap";

let maxPageNo;

const Icons = () => {

  const [cards, setCards] = useState([]);

  const [question, setQuestion] = useState([]);
  const [noun, setNoun] = useState([]);
  const [keyword, setKeyword] = useState([]);
  const [newKeyword, setNewKeyword] = useState([]);
  const [newClassification, setNewClassification] = useState([]);
  const [search, setSearch] = useState('');

  // const [selectCard, setSelectCard] = useState([]);

  const [model, setModel] = useState(false);

  const [viewNo, setViewNo] = useState(3);
  const [selectNo, setSelectNo] = useState(1);

  //데이터 가져오기
  useEffect(() => {

    lodeData(selectNo, search);
    dataCnt(search);
  }, []);

  useEffect(() => {
    lodeData(search);
    dataCnt(search);
  }, [selectNo]);

  useEffect(() => {
    lodeData(search);
    dataCnt(search);
  }, [search]);

  //방 개수
  const dataCnt = useCallback((search) => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/question_list_cnt`,
      {
        srch: search,
      })
      .then((res) => {
        if (res != 'ERROR') {
          var roomCnt = res[0].totalRows;
          maxPageNo = Math.ceil(roomCnt / 10);
        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [search, maxPageNo])

  //질문 분류 리스트
  const lodeData = useCallback((search) => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/question_list`,
      {
        srch: search,
        pageno: selectNo,
      })
      .then((res) => {
        if (res != 'ERROR') {
          console.log(res);
          setCards(res);
        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [selectNo, search])

  //분류명 변경
  const nameCorrection = useCallback(async () => {

    const res = await postAxios(`${CMM.SERVER_URL_API}/admin/question_edit`,
      {
        q_idx: etcStore.mainData.keyword_selcard.q_idx,
        question: question,
      })
      .then((res) => {
        if (res != 'ERROR') {
          lodeData(search);
        }
      })
      .catch((e) => {
        console.log('error::', e.message);
      })
  }, [question, etcStore.mainData.keyword_selcard]);

  //분류 추가
  const questionAdd = useCallback(async () => {

    //공백체크
    if (newClassification != '' && newClassification != undefined) {

      const res = await postAxios(`${CMM.SERVER_URL_API}/admin/question_add`,
        {
          question: newClassification,
        })
        .then((res) => {
          if (res != 'ERROR') {
            lodeData(search);
            setNewClassification('');
            setModel(false);
          }
        })
        .catch((e) => {
          console.log('error::', e.message);
        })

    } else {
      //토스트 메시지
      toast.error('질문 분류를 먼저 입력해주세요.', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: {
          marginTop: '400px'
        }
      });
    }


  }, [newClassification]);

  // 분류 삭제
  const questionDel = useCallback(async () => {

    const res = await postAxios(`${CMM.SERVER_URL_API}/admin/question_del`,
      {
        q_idx: etcStore.mainData.keyword_selcard.q_idx,
      })
      .then((res) => {
        if (res != 'ERROR') {
          lodeData(search);
          etcStore.updMainData({ ...etcStore.mainData, keyword_selcard: '' });
        }
      })
      .catch((e) => {
        console.log('error::', e.message);
      })

  }, [etcStore.mainData.keyword_selcard.q_idx]);

  //키워드 가져오기
  const getKwd = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/question_kwd`,
      {
        q_idx: etcStore.mainData.keyword_selcard.q_idx,
      })
      .then((res) => {
        if (res != 'ERROR') {
          // console.log(res);
          setKeyword(res);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [keyword, etcStore.mainData.keyword_selcard]);

  // 키워드 추가
  const addKwd = useCallback(async () => {

    //공백체크
    if (newKeyword != '' && newKeyword != undefined) {

      const res = await postAxios(`${CMM.SERVER_URL_API}/admin/kwd_add`,
        {
          q_idx: etcStore.mainData.keyword_selcard.q_idx,
          keywords: newKeyword,
        })
        .then((res) => {
          if (res != 'ERROR') {
            getKwd();
            setNewKeyword('');
          }
        })
        .catch((e) => {
          console.log('error::', e.message);
        })

    } else {
      //토스트 메시지
      toast.error('추가할 키워드를 먼저 입력해주세요.', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: {
          marginTop: '400px'
        }
      });
    }


  }, [newKeyword, etcStore.mainData.keyword_selcard]);

  // 키워드 삭제
  const delKwd = useCallback(async (kwd_id) => {

    const res = await postAxios(`${CMM.SERVER_URL_API}/admin/kwd_del`,
      {
        kwd_id: kwd_id,
      })
      .then((res) => {
        if (res != 'ERROR') {
          getKwd();
        }
      })
      .catch((e) => {
        console.log('error::', e.message);
      })

  }, [keyword]);

  //고유명사 가져오기
  const getNouns = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/question_noun`,
      {
        q_idx: etcStore.mainData.keyword_selcard.q_idx,
      })
      .then((res) => {
        if (res != 'ERROR') {
          console.log(res);

          setNoun(res[0].noum);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [noun, etcStore.mainData.keyword_selcard]);

  //고유명사 저장
  const setNouns = useCallback(async () => {

    const res = await postAxios(`${CMM.SERVER_URL_API}/admin/noun_add`,
      {
        q_idx: etcStore.mainData.keyword_selcard.q_idx,
        noun: noun,
      })
      .then((res) => {
        if (res != 'ERROR') {
          getNouns();
        }
      })
      .catch((e) => {
        console.log('error::', e.message);
      })
  }, [noun, etcStore.mainData.keyword_selcard]);

  //페이지 이동 버튼
  const PageNoBtn = ({ maxPage }) => {

    const handleButtonClick = (number) => {
      setSelectNo(number);
    };

    const getPageNumbers = () => {
      const numbers = [];
      const start = Math.max(1, Math.min(viewNo - 2, maxPage - 4)); // 시작 페이지
      const end = Math.min(start + 4, maxPage); // 끝 페이지

      for (let i = start; i <= end; i++) {
        numbers.push(i);
      }

      return numbers;
    };

    return (
      <Row className="justify-content-center">
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            setViewNo(3);
            console.log(viewNo);
          }}><AiOutlineDoubleLeft /></Button>
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            if (viewNo >= 3) {
              setViewNo(viewNo - 5);
            }
          }}><GoChevronLeft /> </Button>
        {getPageNumbers().map((index) => (
          <Button
            key={index}
            className={`btn btn-sm text-break ml-3 mr-3 shadow-none border-0 `}
            style={selectNo == index ? { backgroundColor: '#3094FF', color: '#fff', alignItems: 'center' } : { backgroundColor: '#FFF', alignItems: 'center' }}
            onClick={() => handleButtonClick(index)}
          >
            {index}
          </Button>
        ))}
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            if (viewNo <= maxPageNo - 4) {
              setViewNo(viewNo + 5);
            }
          }}><GoChevronRight /></Button>
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            setViewNo(maxPageNo - 2);
            console.log(viewNo);
          }}>< AiOutlineDoubleRight /></Button>
      </Row>
    );
  }


  return (
    <>
      <Header />
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <Container className="mt--7 position-absolute start-0" fluid style={{ maxWidth: '1300px', }}>
        <Modal isOpen={model} className="custom-modal"
          style={{
            overlay: {
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.3)'
            }
          }} >
          <div className="modal-dialog pt-9" style={{ maxWidth: '500px', maxHeight: '270px' }}>
            <div className="modal-content" >
              <div className="modal-header pb-0">
                <h1 className="modal-title" style={{ color: 'black' }}>
                  질문 분류
                </h1>
              </div>
              <div className="modal-body p-3">
                <Input
                  className="form-control-alternative mb-2 mt-3"
                  placeholder="질문 분류를 입력하세요"
                  value={newClassification}
                  onChange={(e) => {
                    setNewClassification(e.target.value);
                  }}
                />
              </div>
              <div className="modal-footer p-1 pb-3">
                <button
                  onClick={() => setModel(false)}
                  className="btn text-center pl-2 pr-2 pt-1 pb-1 text-white"
                  style={{ backgroundColor: '#3094FF', fontWeight: 'normal' }}
                >
                  취소
                </button>
                <button
                  onClick={questionAdd}
                  className="btn text-center pl-2 pr-2 pt-1 pb-1 text-white"
                  style={{ backgroundColor: '#3094FF', fontWeight: 'normal' }}
                >
                  추가
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <div className="w-100 d-flex justify-content-end">
          <div className="col-lg-4 text-right bg-white p-0 border rounded-lg mb-2 d-flex align-items-center">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-2">
              <path d="M12.1498 10.6918H11.3819L11.1098 10.4294C12.0623 9.32133 12.6358 7.88279 12.6358 6.3179C12.6358 2.82847 9.80732 0 6.3179 0C2.82847 0 0 2.82847 0 6.3179C0 9.80732 2.82847 12.6358 6.3179 12.6358C7.88279 12.6358 9.32133 12.0623 10.4294 11.1098L10.6918 11.3819V12.1498L15.5517 17L17 15.5517L12.1498 10.6918ZM6.3179 10.6918C3.89766 10.6918 1.94397 8.73814 1.94397 6.3179C1.94397 3.89766 3.89766 1.94397 6.3179 1.94397C8.73814 1.94397 10.6918 3.89766 10.6918 6.3179C10.6918 8.73814 8.73814 10.6918 6.3179 10.6918Z" fill="#434343" />
            </svg>
            <Input
              type="text"
              className="text-dark d-inline-block border-0"
              value={search}
              placeholder="질문 카테고리 입력"
              onChange={(e) => {
                setSearch(e.target.value)
              }}
            />
          </div>
        </div>
        <Card>
          <CardHeader className="bg-white">
            <div className="font-weight-bold d-none d-sm-block"
              style={{ lineHeight: 1.2 }}>
              <h1 className="d-inline-block"
                style={{ color: 'black' }}>
                키워드 관리</h1>
              <div className=" d-inline-block ml-4 ">
                <button color="primary"
                  onClick={() => setModel(true)}
                  className="btn text-center pl-2 pr-2 pt-1 pb-1 mb-2 text-white"
                  style={{ backgroundColor: '#3094FF' }}>
                  <FontAwesomeIcon icon={faPlus} />
                  &nbsp;&nbsp;&nbsp;질문 분류
                </button>
              </div>
              <div className=""
                style={{ color: '#727272' }}>
                고객의 질문 의도를 파악하기 위한 질문 분류를 추가하고
              </div>
              <div className=""
                style={{ color: '#727272' }}>
                해당 분류에 속하는 키워드를 관리할 수 있습니다.
              </div>
            </div>
            <div className="font-weight-bold d-sm-none "
              style={{ lineHeight: 1.2 }}>
              <h2 className="d-inline-block"
                style={{ color: 'black' }}>
                키워드 관리</h2>
              <div className=" d-inline-block ml-3 ">
                <button color="primary"
                  onClick={() => setModel(true)}
                  className="btn text-center pl-2 pr-2 pt-1 pb-1 mb-2 text-white"
                  style={{ backgroundColor: '#3094FF', fontSize: '13px' }}>
                  <FontAwesomeIcon icon={faPlus} />
                  &nbsp;&nbsp;&nbsp;질문 분류
                </button>
              </div>
              <div className="   "
                style={{ color: '#727272', fontSize: '14px' }}>
                고객의 질문 의도를 파악하기 위한 질문 분류를 추가하고
              </div>
              <div className=" "
                style={{ color: '#727272', fontSize: '14px' }}>
                해당 분류에 속하는 키워드를 관리할 수 있습니다.
              </div>
            </div>
          </CardHeader>
          <CardBody className=" p-0 ">
            <Row className=" px-3">
              <Col className="mb-xl-0 p-0" xl="6">
                {cards.map((card, cardIndex) => (
                  <Card key={cardIndex} className="shadow"
                    onClick={(e) => {
                      etcStore.updMainData({ ...etcStore.mainData, keyword_selcard: card });
                      // setSelectCard(card);
                      setQuestion(card.question);

                      getKwd();
                      getNouns();
                    }}>
                    <CardHeader className="bg-transparent">
                      <Row className="align-items-center ml-1">
                        <h3 className="mb-0">{card.question}</h3>
                      </Row>
                    </CardHeader>

                  </Card>
                ))}
              </Col>
              <Col xl="6" className="p-0">
                <Card className="" >
                  <CardBody className='p-0 ' style={{ overflowY: 'auto', minHeight: '683px' }}>
                    {(etcStore.mainData.keyword_selcard != '') && (
                      <>
                        <div className="mx-3 my-2">
                          <div>
                            <label
                              className="form-control-label  "
                              htmlFor="input-username"
                            >
                              분류명
                            </label>
                            <Row >
                              <Col lg="11">
                                <Input
                                  className="form-control-alternative mb-2 text-dark"
                                  value={question}
                                  onChange={(e) => setQuestion(e.target.value)}
                                />
                              </Col>
                              <button
                                onClick={() => nameCorrection()}
                                className="btn text-center p-2 mt-1 mb-3 text-white pb-0 "
                                style={{ backgroundColor: '#3094FF', fontWeight: 'normal', borderRadius: '5px' }}>
                                저장
                              </button>
                            </Row>
                          </div>
                          <div>
                            <label
                              className="form-control-label text-md "
                              htmlFor="input-username"
                            >
                              고유명사
                            </label>
                            <Input
                              className="form-control-alternative mb-2 text-dark"
                              style={{ minHeight: '180px' }}
                              id="exampleText"
                              placeholder="콤마(,)로 구분 예: 제품명,apple"
                              name="text"
                              value={noun}
                              onChange={(e) => {
                                setNoun(e.target.value);
                              }}
                              type="textarea"
                            />
                            <div className="d-flex">
                              <button
                                onClick={() => {
                                  setNouns();
                                }}
                                className="btn p-2 mt-1 mb-3 text-white pb-0 ml-auto"
                                style={{ backgroundColor: '#3094FF', fontWeight: 'normal', borderRadius: '5px' }}>
                                저장
                              </button>
                            </div>
                          </div>
                          <div>
                            <label
                              className="form-control-label  "
                              htmlFor="input-username"
                            >
                              키워드
                            </label>
                            <Row >
                              <Col lg="11">
                                <Input
                                  className="form-control-alternative mb-2 text-dark"
                                  placeholder="최대 5개까지 콤마(,)로 구분 예: 회사,소개"
                                  value={newKeyword}
                                  onChange={(e) => {
                                    setNewKeyword(e.target.value)
                                  }}
                                />
                              </Col>
                              <button
                                onClick={() => addKwd()}
                                className="btn text-center p-2 mt-1 mb-3 text-white pb-0 "
                                style={{ backgroundColor: '#3094FF', fontWeight: 'normal', borderRadius: '5px' }}>
                                추가
                              </button>
                            </Row>
                            <div className=" "
                              style={{ minHeight: '130px' }}>
                              <List style={{ flex: 1, justifyContents: 'center', alignItems: 'center' }}>
                                {keyword.map((keyword, keywordIndex) => (
                                  <li key={keywordIndex}>
                                    {keyword.keyword}
                                    <Button
                                      size="sm"
                                      onClick={() => delKwd(keyword.kwd_id)}
                                      style={{ width: 15, height: 15, top: -2, justifyTracks: 'center', alignItems: 'center', padding: 0, margin: 0, marginLeft: 5, marginBottom: 2, backgroundColor: '#e6e6e6', borderRadius: 20, boxShadow: 'none', border: 'none' }}>
                                      <FontAwesomeIcon icon={faX} width={7} style={{ marginBottom: 1.5 }} />
                                    </Button>
                                  </li>
                                ))}
                              </List>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex">
                          <button
                            onClick={() => {
                              questionDel();
                            }}
                            className="btn p-2 mb-2 mr-2 text-white pb-0 ml-auto"
                            style={{ backgroundColor: '#EC3939', fontWeight: 'normal', borderRadius: '5px' }}>
                            삭제
                          </button>
                        </div>
                      </>


                    )}
                    {etcStore.mainData.keyword_selcard == '' && (
                      <div className=" text-center mt-5"
                        style={{ color: '#757575' }}>
                        질문 분류를 선택하세요.
                      </div>
                    )}

                  </CardBody>
                </Card>
              </Col>
            </Row>

          </CardBody>

          <div className="p-2 bg-white " style={{ height: '70px' }} >
            <PageNoBtn maxPage={maxPageNo} />
          </div>
        </Card>
      </Container >
    </>
  );
};

export default Icons;
